export default "__VITE_ASSET__D2uFZ9$$__"